import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import News from '../../news/news';
import { useTranslation } from "react-i18next";

export default function StockAnalysisNews() {
  const { t } = useTranslation();
  const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);
  const [entityIds, setEntityIds] = useState([]);

  useEffect(() => {

    if (selectedSecurity?.code) {
      setEntityIds([selectedSecurity.code]);
    }
  }, [selectedSecurity]);

  return (
    <div>
      <News
        constutientEntityId={'ANY'}
        entityIds={entityIds}
        showLiveTicker={false}
        hasEntityId={true}
        visibleSearch={false}
        beginOfDate={2} // Set to 2 years of history
        hideOtherCategory={true}
      />
    </div>
  );
}
